<template>
    <div
        class="RouteHeadAndCrumbs"
        :style="`background:url(${backgroundImg}) no-repeat;background-size:cover;height:${scrollerHeight}`"
    >
        <div class="breadcrumbs-container">
            <img
                class="local-img"
                src="../../assets/images/local-white.png"
                alt=""
            />
            <span>当前位置：</span>
            <el-breadcrumb
                class="breadcrumbs-body"
                separator-class="el-icon-arrow-right"
            >
                <template v-for="item in breadcrumbsInfo">
                    <el-breadcrumb-item
                        :key="item.routeName"
                        class="breadcrumbs-item"
                        :to="item.routeTo ? item.routeTo : null"
                    >
                        <span>{{ item.routeLabel }}</span>
                    </el-breadcrumb-item>
                </template>
            </el-breadcrumb>
        </div>
    </div>
</template>

<script>
export default {
        computed:{
        scrollerHeight(){
            const containerHeight  = document.documentElement.clientWidth / 1920 * 700;
            console.log(containerHeight)
            return containerHeight + 'px';
        },
    },
    props: ["backgroundImg", "breadcrumbsInfo"],
    
};
</script>

<style lang="scss">
@import "../../assets/scss/components/Public/RouteHeadAndCrumbs.scss";
</style>
